<template>
  <section id="hot-column">
    <div class="title">
      <span class="iconfont" v-if="!noicon">&#xe612;</span>
      <h3 :class="[noicon ? 'use-homepage':'']">
        <!-- <img src="~assets/img/icon_hotColumn.png" alt> -->
        {{ $t('hot-column.title') }}
      </h3>
    </div>
    <ul>
      <li v-for="(item,index) in hotColumn" :key="index">
        <section class="user-info">
          <a class="avatar" :href="$i18n.path(`user/${item.owner.userId}`)" target="_blank">
            <img :src="item.owner.avatar" alt>
          </a>
          <div class="user-name">
            <a :href="$i18n.path(`user/${item.owner.userId}`)" target="_blank">
              <span class="user-nick">{{item.owner.nick}}</span>
            </a>
            <span class="user-pay">{{item.subscribeCount}} 人关注</span>
          </div>
        </section>
        <a :href="item.latestPost.link" target="_blank" v-if="item.latestPost">
          <span>{{item.latestPost.createTimestamp | siederBarformatTime}}更新：</span>
          {{item.latestPost.title}}
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import initTime from "~/plugins/initTime";
export default {
  props: ["hotColumn", "noicon"],
  components: {},
  methods: {
    changeHotColumn() {
      this.$emit("changeHotColumn");
    },
    initTime(t) {
      return initTime(t).format("Y-M-D H:m:s");
    }
  }
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

#hot-column {
  background-color: #fff;
  position: relative;

  .title {
    padding-top: 20px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    .iconfont {
      color: #478cf3;
      font-size: 28px;
      line-height: 28px;
      font-weight: 100;
    }
    h3 {
      display: inline-block;
      font-size: 16px;
      color: #333;
      line-height: 28px;
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    .use-homepage {
      line-height: 24px;
      font-weight: bold;
      font-size: 16px;
      color: rgba(34, 34, 34, 1);
    }
  }
  ul {
    // width: 100%;
    margin: 0 20px;
    margin-top: 16px;
    padding: 14px 0px 10px 0px;
    border-top: 0.5px solid #e8e8e8;

    li {
      // height: 126px;
      margin-bottom: 14px;
      border-bottom: 0.5px dashed #e8e8e8;
      padding: 0 10px 14px 0px;

      &:last-child {
        border-bottom: none;
        margin: 0;
      }

      .user-info {
        display: flex;
        align-items: center;

        a {
          display: block;
        }

        .avatar {
          height: 64px;
          width: 64px;
          border-radius: 50%;
          border: 1px solid #e8e8e8;
          position: relative;
          z-index: 5;
          overflow: hidden;

          img {
            height: 100%;
            width: 100%;
          }
        }

        .user-name {
          margin-left: 12px;

          .user-nick {
            line-height: 25px;
            font-size: 16px;
            font-weight: 600;
            color: rgba(34, 34, 34, 1);
          }

          .user-pay {
            font-size: 13px;
            color: rgba(131, 141, 151, 1);
          }
        }
      }

      > a {
        display: block;
        font-size: 14px;
        padding-top: 10px;
        color: #222222;
        line-height: 18px;
        text-overflow: ellipsis;
        max-height: 48px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        span {
          color: #3278d2;
          // margin-right: 6px;
        }
      }
    }
  }
}
</style>
